import React from "react";
import ResendIcon from "../../../icons/resend.icon";
import UserLogo from "../../../icons/user.logo";
import styles from "./pending-distributor-row.module.scss";
import cn from "../../../../Utils/class-names.utils";

const getContactBgColor = (bgColor) => {
  const colorMap = {
    "violet": styles.contactBgViolet,
    "orange": styles.contactBgOrange,
    "warning": styles.contactBgWarning,
    "success": styles.contactBgSuccess,
  };
  return colorMap[bgColor] || styles.contactBgDefault;
};

export const PendingDistributorRow = ({ data }) => {
  const contactBgClass = getContactBgColor(data.contact?.bgColor || "violet");
  const contactInitial = data.contact?.name?.charAt(0).toUpperCase() || "";

  const handleResendInvite = () => {
    console.log("Resend invite for:", data.id);
  };

  return (
    <tr className={styles.pendingRow}>
      <td className={styles.tableCell}>
        <div className={styles.companyCell}>
          <div className={styles.companyLogoWrapper}>
            <UserLogo 
              width="32" 
              height="32" 
              fill="#D4D6DD"
            />
          </div>
          <div className={styles.companyName}>{data.company?.name || ""}</div>
        </div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.countryCell}>{data.country || ""}</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.contactCell}>
          <div className={cn(styles.contactInitial, contactBgClass)}>
            {contactInitial}
          </div>
          <div className={styles.contactInfo}>
            <div className={styles.contactName}>{data.contact?.name || ""}</div>
            <div className={styles.contactEmail}>{data.contact?.email || ""}</div>
          </div>
        </div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.statusCell}>
          <div className={styles.statusText}>Pending</div>
          <button
            type="button"
            onClick={handleResendInvite}
            className={styles.resendButton}
            aria-label="Resend invitation"
          >
            <div className={styles.resendIconWrapper}>
              <ResendIcon className={styles.resendIcon} />
            </div>
            <div className={styles.resendText}>Resend Invite</div>
          </button>
        </div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.emptyCell} />
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>0</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>0</div>
      </td>

      <td className={styles.tableCell}>
        <div className={styles.numberCell}>0</div>
      </td>
    </tr>
  );
};

